import { EditOrganizationFormData, FormErrors } from './types';

export const validateEditOrganizationForm = (
  _formData: EditOrganizationFormData,
): { isValid: boolean; errors: FormErrors } => {
  const errors: FormErrors = {};

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
